export type BeautySimulatorInput = {
  appointments: number;
  ticket: number;
  absenceRate: number;
};

export function calculateBeautySimulator({
  appointments,
  ticket,
  absenceRate
}: BeautySimulatorInput) {
  const missedAppointments = Math.round(appointments * (absenceRate / 100));
  const monthlyLoss = missedAppointments * ticket;
  const recoveredEstimate = Math.round(monthlyLoss * 0.3);
  const annualLoss = monthlyLoss * 12;

  return {
    missedAppointments,
    monthlyLoss,
    recoveredEstimate,
    annualLoss
  };
}
